import $ from 'jquery';
import config from '../config';
const URL_API = config.urlApi+'controllers/getCustomData.controller.php';

export default function getAllData(values){
    return $.ajax({
        data: values,
        url: URL_API,
        type: 'POST',
        contentType: false,
        processData: false
    })
}